module.exports = {
  changeChargeNo: 'Số thứ tự đơn',
  changeReason: 'Lý do thay đổi',
  state: 'Tiến độ đơn',
  jobNo: 'Mã nghiệp vụ',
  customerId: 'Đơn vị ủy quyền',
  receivable: 'Loại chi phí',
  dateCreated: 'Thời gian nộp đơn',
  createdBy: 'Người nộp đơn',
  judgeDutyResult: 'Kết quả xét trách nhiệm',
  judgeDutyDate: 'Thời gian xét trách nhiệm',
  judgeDutyBy: 'Người xét trách nhiệm',
  businessAuditResult: 'Kết quả duyệt thương mại',
  businessAuditReason: 'Lý do từ chối',
  businessAuditDate: 'Thời gian duyệt thương mại',
  businessAuditBy: 'Người duyệt thương mại',
  judgeClosedResult: 'Quyết toán',
  judgeClosedDate: 'Thời gian quyết toán',
  judgeClosedBy: 'Người quyết toán',
  returnReason: 'Lý do trả lại',
  returnDate: 'Thời gian trả lại',
  returnBy: 'Người trả lại',
  remarks: 'Ghi chú',
  details: 'So sánh trước-sau thay đổi',
  revoke: 'Hủy đơn',
  return: 'Trả lại',
  judgeDuty: 'Xét trách nhiệm',
  businessAudit: 'Duyệt thương mại',
  judgeClosed: 'Quyết toán',
  exportDetail: 'Xuất chi tiết',
  tabJudgeDuty: 'Chờ xét trách nhiệm',
  tabBusinessAudit: 'Chờ duyệt thương mại',
  tabJudgeClosed: 'Chờ quyết toán',
  tabManagerReview: 'Chờ giám đốc duyệt',
  tabAll: 'Tất cả',
  dateCreatedDay: 'Ngày nộp đơn',
  judgeDutyDateDay: 'Ngày xét trách nhiệm',
  businessAuditDateDay: 'Ngày duyệt thương mại',
  judgeClosedDateDay: 'Ngày quyết toán',
  applyChangeCharge: 'Đơn thay đổi chi phí',
  applyAddCharge: 'Đơn thêm chi phí',
  applyDeleteCharge: 'Đơn xóa chi phí',
  showApplyChangingCharge: 'Xem duyệt thay đổi chi phí',
  ChangeTheChargesInTheExpenseReview: 'Chi phí trong đơn thay đổi',
  actionType: 'Loại đơn',
  confirmApplyDeleteCharge: 'Xác nhận xóa chi phí này?',
  changeReasonCannotBeNull: 'Lý do thay đổi không được để trống.',
  changeReasonIsTooLong: 'Lý do thay đổi tối đa 100 ký tự.',
  judgeDutyMessage: 'Nhân viên có trách nhiệm trong thay đổi này?',
  judgeDutyYes: 'Có trách nhiệm',
  judgeDutyNo: 'Không có trách nhiệm',
  businessAuditMessage: 'Đồng ý thay đổi chi phí không?',
  businessAuditAgree: 'Đồng ý',
  businessAuditRefuse: 'Từ chối',
  businessAuditReasonNotNull: 'Vui lòng nhập lý do từ chối',
  judgeClosedMessage: 'Thay đổi chi phí lần này là trước hay sau khi đóng sổ?',
  judgeClosedBefore: 'Trước khi đóng sổ',
  judgeClosedAfter: 'Sau khi đóng sổ',
  returnMessage: 'Yêu cầu này sẽ trở về trạng thái ban đầu',
  returnMessageConfirm: 'Xác nhận trả lại không?',
  returnReasonNotNull: 'Vui lòng nhập lý do trả lại',
  revokeMessage: 'Chỉ có thể hủy yêu cầu chưa được phê duyệt, vui lòng kiểm tra',
  revokeMessageConfirm: 'Sau khi hủy không thể khôi phục, xác nhận hủy không?',
  modifyBefore: 'Trước khi sửa',
  modifyAfter: 'Sau khi sửa',
  estimateProfit: 'Lợi nhuận dự kiến toàn hóa đơn:',
  generateByContract: 'Áp dụng giá ước tính',
  generateByContractConfirm: 'Xác nhận áp dụng giá ước tính không?',
  JudgmentResult: 'Kết quả xác định trách nhiệm',
  ChangeCharge: 'Thay đổi chi phí',
  OnlyRejectedApplicationFormsCanBeCopied: 'Chỉ được sao chép đơn yêu cầu đã bị từ chối',
  JudgeBeforeAndAfterAccountClosing: 'Xác định trước/sau khi đóng sổ',
  FeesIncurred: 'Phát sinh chi phí',
  updateSuccess: 'Cập nhật tỷ giá chi phí chưa thao tác tương ứng 【{0}】 thành công',
  exchangeRates: 'Khoảng tỷ giá thay đổi, cập nhật tỷ giá chi phí không?',
  exchangeRates2: 'Khoảng tỷ giá hóa đơn chính thay đổi, cập nhật tỷ giá chi phí của hóa đơn phụ không?',
  chargeLanguage: 'Mô tả ngôn ngữ',
  costDescription: 'Mô tả chi phí'
}
